import { render, staticRenderFns } from "./AddEditModal.vue?vue&type=template&id=65e034b6&"
import script from "./AddEditModal.vue?vue&type=script&lang=js&"
export * from "./AddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports